import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocalStorage {

  constructor() { }

  /**
   * Decrypt a stored value when encryption is enabled.
   * Falls back to the raw value when it was written in plain text
   * (or was encrypted with a different secret), so a legacy/plain entry
   * never throws "Malformed UTF-8 data".
   *
   * @param {string} raw
   * @return {string | null}
   */
  private decryptValue(raw: string): string | null {
    if (!environment.ENCRYPT_LOCAL_STORAGE) return raw;

    try {
      const decrypted = CryptoJS.AES.decrypt(raw, environment.LOCAL_STORAGE_SECRET).toString(CryptoJS.enc.Utf8);
      return decrypted ? decrypted : raw;
    } catch {
      return raw;
    }
  }

  /**
  * store in in localstorage
  * encruption enabled
  * @param {JSON} data
  */
  public storeLoginData(data: any): void {
    if (!data) return;
    const loginData = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.encrypt(JSON.stringify(data), environment.LOCAL_STORAGE_SECRET).toString() : JSON.stringify(data);
    localStorage.setItem('login response', loginData);
  }

  /**
   * get stored used data from localstorage
   * @return {JSON} returns user data
   */
  public getLoginData(): any {
    if (!localStorage.getItem('login response')) return null;
    const loginData = this.decryptValue(localStorage.getItem('login response')!);
    if (!loginData) return null;

    try {
      return JSON.parse(loginData);
    } catch {
      return null;
    }
  }

  /**
   * store any data
   *
   * @param {string} key
   * @param {any} value
   */
  storeData(key: string, value: any): void {
    const data = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.encrypt(JSON.stringify(value), environment.LOCAL_STORAGE_SECRET).toString() : JSON.stringify(value);
    localStorage.setItem(key, data);
  }

  /**
   * Get localstorage value by key
   *
   * @param {string} key
   * @return {any}
   */
  getDataByKey(key: string): any {
    if (!localStorage.getItem(key)) return null;
    const data = this.decryptValue(localStorage.getItem(key)!);
    if (!data) return null;

    try {
      return JSON.parse(data);
    } catch (error) {
      // If parsing fails, return the raw data (e.g., for plain string tokens)
      return data;
    }
  }

  /**
   * Params local storage service
   * @param {string}key
   */
  clearLocalStorage(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Clears all storage
   */
  clearAllStorage() {
    localStorage.clear();
  }

  /**
   * Sets token
   * @param token
   */
  setToken(token: string): void {
    this.storeData('accessToken', token);
  }

  /**
   * Gets token
   * @returns token
   */
  getToken(): string | null {
    return this.getDataByKey('accessToken');
  }

  /**
   * Removes token
   * @returns
   */
  removeToken() {
    return localStorage.removeItem('accessToken');
  }
}
